import {
    Box,
    Button,
    CircularProgress,
    Container,
    TextField,
    Typography,
    Toolbar,
    Link,
} from "@mui/material";
import { useCallback, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";

import ChikoLogoAzul from "../static/chiko_logo_azul.png";

const ForgotPasswordPage = () => {
    const backendEndpoint = process.env.REACT_APP_BACKEND_ENDPOINT;

    const [email, setEmail] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [apiError, setApiError] = useState("");
    const [isEmailSent, setIsEmailSent] = useState(false);

    const emailRegex = useMemo(() => /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/, []);

    const navigate = useNavigate();

    const isFormValid = useMemo(() => {
        if (!email) {
            setErrorMessage("E-mail deve ser preenchido.");
            return false;
        } else if (!emailRegex.test(email)) {
            setErrorMessage("Preencha com um e-mail válido.");
            return false;
        }
        return true;
    }, [email, emailRegex]);

    const handleSendEmail = useCallback(() => {
        setIsSubmitted(true);
        if (!isFormValid) return;

        setIsLoading(true);

        fetch(`${backendEndpoint}/forgot_password/`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                email,
            }),
        })
            .then(async (response) => {
                if (response.ok) {
                    const result = await response.json();
                    return result;
                } else {
                    const result = await response.json();
                    throw new Error(result.detail);
                }
            })
            .then(() => {
                setIsLoading(false);
                setIsEmailSent(true);
            })
            .catch((error) => {
                setApiError(`${error}`.replace("Error: ", ""));
                setIsLoading(false);
            });
    }, [isFormValid, backendEndpoint, email]);

    return (
        <Container maxWidth="sm">
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "60vh",
                }}
            >
                <Toolbar
                    sx={{
                        display: "flex",
                        justifyContent: "center",
                        mt: 2,
                        mb: 5,
                    }}
                >
                    <img src={ChikoLogoAzul} alt="Chiko Logo" height="80" />
                </Toolbar>

                {/*}
                <Box sx={{ width: "100%" }}>
                    <IconButton
                        title="voltar"
                        edge="end"
                        aria-label="edit"
                        onClick={() => navigate("/")}
                    >
                        <ArrowBack />
                    </IconButton>
                </Box>
                */}

                {isEmailSent ? (
                    <Typography
                        variant="h8"
                        textAlign="center"
                        marginTop="48px"
                        color="#777"
                    >
                        <Box sx={{ margin: "20px" }}>
                            Um e-mail foi enviado para {email}. Siga as
                            instruções para redefinir sua senha.
                        </Box>
                        <Link
                            variant="text"
                            sx={{
                                alignSelf: "flex-start",
                                textDecoration: "none",
                                ":hover": { cursor: "pointer" },
                            }}
                            onClick={() => navigate("/")}
                        >
                            Ir para o login
                        </Link>
                    </Typography>
                ) : (
                    <>
                        <Typography variant="div" gutterBottom>
                            Redefinir sua senha
                        </Typography>

                        <TextField
                            value={email}
                            onChange={(e) => {
                                setEmail(e.target.value);
                            }}
                            label="Digite seu e-mail"
                            variant="outlined"
                            fullWidth
                            margin="normal"
                            error={!isFormValid && isSubmitted}
                            helperText={
                                !isFormValid && isSubmitted
                                    ? errorMessage
                                    : undefined
                            }
                        />

                        {apiError ? (
                            <Typography variant="h6">{apiError}</Typography>
                        ) : null}

                        <Button
                            variant="contained"
                            color="primary"
                            sx={{
                                marginTop: 2,
                                marginBottom: 2,
                                padding: "14px !important",
                            }}
                            fullWidth
                            startIcon={
                                isLoading ? (
                                    <CircularProgress
                                        size="16px"
                                        color="inherit"
                                    />
                                ) : undefined
                            }
                            onClick={handleSendEmail}
                        >
                            Solicitar nova senha
                        </Button>

                        <Link
                            variant="text"
                            sx={{
                                alignSelf: "flex-start",
                                textDecoration: "none",
                                ":hover": { cursor: "pointer" },
                            }}
                            onClick={() => navigate("/")}
                        >
                            Voltar
                        </Link>
                    </>
                )}
            </Box>
        </Container>
    );
};

export default ForgotPasswordPage;
